<section>
    <div class="top_icon">
        <div class="top_icon_back" matTooltip="Expand All" (click)="expandAllDetails()"><mat-icon
                class="top_icon_mat">arrow_drop_down</mat-icon>
        </div>
        <div class="top_icon_back" matTooltip="Collapse All" (click)="collapseAllDetails()"><mat-icon
                class="top_icon_mat">arrow_drop_up</mat-icon>
        </div>
    </div>
    <div class="step_bottom">
        <ul class="tree">
            <ng-container *ngFor="let step of stepsData">
                <li class="parent loopli">
                    <details [open]="step.status === 'INPROGRESS' || step.order === expandStep">
                        <summary>
                            <div class="step">
                                <div class="step_title">{{ step.suiteName != ''? step.suiteName + " > " : ""}}{{
                                    step.stepName}}</div>
                                <!-- <div class="step_details">
                                    <div>
                                        <div *ngIf="step.status === 'FAILED'" class="center">
                                            <mat-icon class="fail">close</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === 'PASSED'" class="center">
                                            <mat-icon class="pass">done</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === 'INPROGRESS'" class="center">
                                            <div *ngIf="reportStatus !== 'Aborted'" class="loader"></div>
                                            <mat-icon *ngIf="reportStatus === 'Aborted'" class="fail" matTooltip="Aborted" matTooltipPosition="above">not_interested</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === ''" class="center">
                                            <div *ngIf="reportStatus !== 'Aborted' && reportStatus !== 'Execution Failed' && reportStatus !== 'Failed' && reportStatus !== 'Completed'" class="loading-spinner">
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ellipsis" matTooltip="{{(step.endTime - step.startTime) | duration}}"
                                        *ngIf="step.status === 'FAILED' || step.status === 'PASSED'">{{(step.endTime -
                                        step.startTime) | duration}}</div>
                                </div> -->
                            </div>
                        </summary>
                        <ul class="step_back">
                            <ng-container
                                *ngTemplateOutlet="stepDataTemplate; context: { step: step, cmdStepsData: step.commandStepsData, prefix: '' }"></ng-container>
                        </ul>
                    </details>
                </li>
            </ng-container>
        </ul>
    </div>
</section>

<ng-template #stepDataTemplate let-stepsData="cmdStepsData" let-step="step" let-prefix="prefix">
    <ng-container *ngFor="let ctv of stepsData; let i = index">
        <li [attr.name]="'loopList' + prefix">
            <ng-container *ngIf="isObject(ctv)">
                <div class="step_single" [ngClass]="{'inactive-step': ctv.active === false}">
                    <div>{{i+1}}</div>
                    <ul class="remove">
                        <li class="removeli">
                            <div class=" step_single_details" *ngIf="isObject(ctv)">

                                <div class="first_step_col" *ngIf="ctv.command.name!='comment'">
                                    {{ctv.command.name}}</div>
                                <div class="comment_col" *ngIf="ctv.command.name=='comment'">
                                    <span>{{ctv.value}}</span>
                                </div>
                                <div class="second_step_col"
                                    *ngIf="ctv.command.accepts[0]=='target'&& ctv.command.name!='comment'">
                                    {{ctv.target?.name}}</div>
                                <div class="second_step_col"
                                    *ngIf="ctv.command.accepts[1]=='target' && ctv.command.name!='comment'">
                                    {{ctv.target2?.name}}</div>
                                <div class="third_step_col"
                                    *ngIf="(ctv.command.accepts[0]=='value' && ctv.command.name!='comment')||(ctv.command.accepts[0]=='target'&&ctv.command.accepts[1]=='value') ">
                                    <input matInput [matTooltip]="ctv.value" id="value" name="value"
                                        [(ngModel)]="ctv.value" disabled>
                                </div>
                                <div class="third_step_col"
                                    *ngIf="ctv.command.accepts[1]=='value'&&ctv.command.accepts[0]=='value' && ctv.command.name!='comment'">
                                    <input matInput [matTooltip]="ctv.value2" name="value2" [(ngModel)]="ctv.value2"
                                        disabled>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div>
                        <!-- <div *ngIf="ctv.status === 'FAILED' && ctv.failureMessage" class="center">
                            <mat-icon class="fail">close</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'PASSED' && ctv.warningMessage" class="center">
                            <mat-icon class="warn">close</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'PASSED' && !ctv.warningMessage" class="center">
                            <mat-icon class="pass">done</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'INPROGRESS'" class="center">
                            <div *ngIf="reportStatus !== 'Aborted'" class="loader"></div>
                            <mat-icon *ngIf="reportStatus === 'Aborted'" class="fail" matTooltip="Aborted" matTooltipPosition="above">not_interested</mat-icon>
                        </div>
                        <div *ngIf="step.status === ''" class="center">
                            <mat-icon *ngIf="reportStatus !== 'Aborted' && reportStatus !== 'Execution Failed' && reportStatus !== 'Failed' && reportStatus !== 'Completed'" class="pending">pending</mat-icon>
                        </div> -->
                        <div *ngIf="ctv.visualStatus && ctv.active !== false" class="center">
                            <mat-icon class="fail" (click)="openImages(ctv)">close</mat-icon>
                        </div>
                        <div *ngIf="!ctv.visualStatus && ctv.active !== false" class="center" (click)="openPopup()">
                            <mat-icon class="pass" (click)="openImages(ctv)">done</mat-icon>
                        </div>
                    </div>

                    <!-- <div class="ellipsis" matTooltip="{{(ctv.endTime - ctv.startTime) | duration}}"
                        *ngIf="ctv.status === 'FAILED' || ctv.status === 'PASSED'">{{(ctv.endTime -
                        ctv.startTime) | duration}}</div> -->
                </div>

                <!-- <div *ngIf="ctv.status === 'FAILED' && ctv.failureMessage" class="step_single">
                    <div></div>
                    <div class="fail">{{ctv.failureMessage}}</div>
                </div>
                <div *ngIf="ctv.status === 'PASSED' && ctv.warningMessage" class="step_single">
                    <div></div>
                    <div class="warn">{{ctv.warningMessage}}</div>
                </div> -->
            </ng-container>
            <ng-container *ngIf="isArray(ctv)">
                <!-- <ng-container *ngIf="isArray(ctv) && ctv[0][0]['status'] != ''"> -->
                <div class="loop_btn">
                    <div>{{i+1}}</div>
                    <div class="top_icon_back" matTooltip="Expand All" (click)="expandDetails(prefix + '.' + (i+1))">
                        <mat-icon class="top_icon_mat">arrow_drop_down</mat-icon>
                    </div>
                    <div class="top_icon_back" matTooltip="Collapse All"
                        (click)="collapseDetails(prefix + '.' + (i+1))"><mat-icon
                            class="top_icon_mat">arrow_drop_up</mat-icon>
                    </div>
                </div>
                <ng-container *ngFor="let loopArray of ctv; let j = index">
        <li [attr.name]="'loopList' + prefix + '.' + (i+1) " *ngIf="isLoopRequired(ctv, j)">
            <div class="loop_div">
                <div class="loop_btn">
                    <div>{{j+1}}</div>
                    <div class="top_icon_back" matTooltip="Expand All"
                        (click)="expandDetails(prefix + '.' + (i+1) + '.' + (j+1))"><mat-icon
                            class="top_icon_mat">arrow_drop_down</mat-icon>
                    </div>
                    <div class="top_icon_back" matTooltip="Collapse All"
                        (click)="collapseDetails(prefix + '.' + (i+1) + '.' + (j+1))"><mat-icon
                            class="top_icon_mat">arrow_drop_up</mat-icon>
                    </div>
                </div>
                <div class="loop_div">
                    <ng-container
                        *ngTemplateOutlet="stepDataTemplate; context: { step: step, cmdStepsData: loopArray, prefix: prefix + '.' + (i+1) + '.' + (j+1)}"></ng-container>
                </div>
            </div>
        </li>
    </ng-container>
    </ng-container>
    </li>
    </ng-container>
</ng-template>

<!-- <div *ngIf="showPopup" class="popup-overlay" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
        <mat-icon class="close-btn" (click)="closePopup()">close</mat-icon>
        <div class="image-container">
            <img [src]="image1Url" [ngClass]="{'single-image': !showDiffImg, 'dual-images': showDiffImg}" alt="Image 1">
            <img *ngIf="showDiffImg" [src]="image2Url" class="dual-images" alt="Image 2">
        </div>
    </div>
</div> -->
<div *ngIf="showPopup" class="popup-overlay" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
        <mat-icon class="close-btn" (click)="closePopup()">close</mat-icon>

        <div class="image-container">
            <!-- Executed Image -->
            <div class="image-panel">
                <div class="image-wrapper">
                    <img *ngIf="image1Url" [src]="image1Url" alt="Executed Image" class="comparison-image">
                </div>
            </div>

            <!-- Difference Image (with boundary boxes) -->
            <div class="image-panel">
                <div class="image-wrapper">
                    <img *ngIf="image2Url" [src]="image2Url" alt="Difference Image" class="comparison-image">

                    <!-- Display boundary boxes -->
                    <ng-container *ngFor="let box of coordinates" >
                        <div *ngIf="box.feedback_value != 1" class="highlight-box" [ngStyle]="{
                                'top.px': box.y,
                                'left.px': box.x,
                                'width.px': box.width,
                                'height.px': box.height
                            }">

                            <div class="feedback-buttons" *ngIf="!box.is_feedback_provided">
                                <button class="feedback-btn accept"
                                    (click)="updateFeedback(image1Url, box, 'accept', $event)">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button class="feedback-btn ignore"
                                    (click)="updateFeedback(image1Url, box, 'ignore', $event)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>